export default __webpack_public_path__ + "static/media/Logo-lumys-nom.fe00352e.png";